import { useLayoutEffect, useRef } from 'react';

/**
 * For a mobile list that a detail view replaces (a ticket opened from My Bets
 * or the account statement): the detail opens at the top, and closing it puts
 * the list back where it was instead of at the start.
 *
 * Call `remember()` just before opening the detail, while the list is still on
 * screen; by the time the detail renders, the list's position is gone.
 */
export const useListScrollRestore = (detailOpen: boolean, enabled = true) => {
  const savedY = useRef<number | null>(null);

  useLayoutEffect(() => {
    if (!enabled) return;
    if (detailOpen) {
      window.scrollTo(0, 0);
    } else if (savedY.current != null) {
      window.scrollTo(0, savedY.current);
      savedY.current = null;
    }
  }, [detailOpen, enabled]);

  return {
    remember: () => {
      if (enabled && !detailOpen) savedY.current = window.scrollY;
    },
  };
};
